export default __webpack_public_path__ + "static/media/address.2973ff52.svg";